import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { MouseEvent } from "react";

import { useOverlayZIndex } from "../../lib/overlay-z-index";
import { cn } from "../../lib/utils";
import { useDialogContext } from "./DialogContext";
import { dialogOverlayVariants, type DialogOverlayVariant } from "./styles";

// React bubbles portaled events through the component tree, so a backdrop click would otherwise
// also reach whatever clickable ancestor (a table row, a card) the dialog is rendered inside.
const stopPropagation = (event: MouseEvent) => event.stopPropagation();

export const DialogOverlay = ({ overlay }: { overlay: DialogOverlayVariant }) => {
  const { placement, open } = useDialogContext();
  const { style, className: zClassName } = useOverlayZIndex(placement === "contained" ? "raised" : "modalOverlay");
  const className = cn(dialogOverlayVariants({ placement, overlay }), zClassName);

  // Radix renders no overlay for a non-modal dialog, and a contained dialog is always non-modal.
  if (placement === "contained") {
    return open ? (
      <div data-slot="dialog-overlay" style={style} className={className} onClick={stopPropagation} />
    ) : null;
  }

  return (
    <DialogPrimitive.Overlay data-slot="dialog-overlay" style={style} className={className} onClick={stopPropagation} />
  );
};
